<template>
  <div class="content">
    <base-block class="mb-0" rounded title="Add Bulk Questions">
      <div class="row">
        <div class="col-md-6 form-group">
          Parent Topic
          <b-form-select v-model="parentTopic" @change="getTopics()" required>
            <option
              v-for="(parentTopic, index) in parentTopics"
              :key="index"
              :value="parentTopic.id"
            >
              {{ parentTopic.name }}
            </option>
          </b-form-select>
          <div v-if="parentTopicEmpty" style="color: red">
            Parent topic is required
          </div>
        </div>

        <div class="col-md-6 form-group" v-if="parentTopic != ''">
          Topic
          <b-form-select v-model="topic" @change="getSubtopics()" required>
            <option
              v-for="(topic, index) in topics"
              :key="index"
              :value="topic.id"
            >
              {{ topic.name }}
            </option>
            ></b-form-select
          >
          <div v-if="topicEmpty" style="color: red">Topic is required</div>
        </div>

        <div class="col-md-6 form-group" v-if="topic != ''">
          Sub Topic
          <b-form-select v-model="subtopic" required>
            <option
              v-for="(subtopic, index) in subtopics"
              :key="index"
              :value="subtopic.id"
            >
              {{ subtopic.name }}
            </option>
          </b-form-select>
          <div v-if="subtopicEmpty" style="color: red">
            Subtopic is required
          </div>
        </div>

        <div class="col-md-6 form-group" v-if="subtopic != ''">
          Upload Questions (xls or csv)
          <b-form-file @change="uploadXL" required></b-form-file>
        </div>

        <div class="col-md-6 form-group" v-if="bulkQuestions != ''">
          Upload Images
          <b-form-file multiple="multiple" @change="uploadImage" class="text-nowrap text-truncate" accept="image/jpeg, image/png"></b-form-file>
        </div>
      </div>
      <div class="text-center" v-if="bulkQuestions != ''">
        <b-button
          class="text-center pt-2 pb-2 pr-4 pl-4"
          variant="success"
          style="margin-bottom: 20px"
          @click="addBulkQuestions()"
          type="submit"
          >Save</b-button
        >
      </div>
       <!-- Loader -->
        <b-overlay :show="loader" no-wrap blur="2px" opacity="0.60" class="position-fixed">
          <template #overlay>
            <i class="fa fa-3x fa-cog fa-spin text-primary"></i>
          </template>
        </b-overlay>
    </base-block>
    <br />
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      loader: false,
      multiple: true,
      images: [],
      parentTopicEmpty: false,
      topicEmpty: false,
      subtopicEmpty: false,
      parentTopic: "",
      parentTopics: [],
      topic: "",
      topics: [],
      subtopic: "",
      subtopics: [],
      bulkQuestions: "",
    };
  },
  mounted() {
    this.getParentTopics();
  },
  methods: {
    async getParentTopics() {
      await axios
        .get(`${this.$store.getters.baseUrl}/topics`, {
          headers: {
            Authorization: `Bearer ${this.$store.getters.token}`,
          },
        })
        .then((response) => {
          console.log(response);
          this.parentTopics = response.data.topics;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, error);
        });
    },

    async getTopics() {
      this.parentTopicEmpty = false;
      this.topic = "";
      await axios
        .get(`${this.$store.getters.baseUrl}/topics/${this.parentTopic}`, {
          headers: {
            Authorization: `Bearer ${this.$store.getters.token}`,
          },
        })
        .then((response) => {
          console.log(response);
          this.topics = response.data.topics;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, error);
        });
    },

    async getSubtopics() {
      this.topicEmpty = false;
      this.subtopic = "";
      await axios
        .get(`${this.$store.getters.baseUrl}/topics/${this.topic}`, {
          headers: {
            Authorization: `Bearer ${this.$store.getters.token}`,
          },
        })
        .then((response) => {
          console.log(response);
          this.subtopics = response.data.topics;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, error);
        });
    },

    uploadXL(event) {
      this.bulkQuestions = event.target.files[0];
    },

    uploadZIP(event) {
      this.zip = event.target.files[0];
    },

    uploadImage(event) {
      this.images = event.target.files;
    },

    async addBulkQuestions() {
      if (this.parentTopic == "") {
        this.parentTopicEmpty = true;
        return;
      }

      if (this.topic == "") {
        this.topicEmpty = true;
        return;
      }

      if (this.subtopic == "") {
        this.subtopicEmpty = true;
        return;
      }
       this.loader = true;
      let topicIds = [this.parentTopic, this.topic, this.subtopic];
      const formdata = new FormData();
      formdata.append("topic_id", this.subtopic);
      formdata.append("topic_ids", topicIds);
      formdata.append("import_file", this.bulkQuestions);
      //formdata.append("importImage_file", this.zip);
      for(var i=0; i<this.images.length; i++){
         formdata.append("images["+i+"]", this.images[i]);
      }
     
      console.log(topicIds);
      console.log(this.subtopic);
      await axios
        .post(
          `${this.$store.getters.baseUrl}/question/import_store`,
          formdata,
          {
            headers: {
              Authorization: `Bearer ${this.$store.getters.token}`,
            },
          }
        )
        .then((response) => {
          console.log(response);
          if(response.data.status == "success") {
            this.loader =  false;
            this.$swal("Success", "Bulk question added successfully", "success");
            this.$router.push({name: 'Tables Questions'});
            this.parentTopic = ""
            this.topic = ""
            this.subtopic = ""
            this.bulkQuestions = ""
            this.zip = ""
            this.parentTopicEmpty = false,
            this.topicEmpty = false,
            this.subtopicEmpty = false
          } else {
            this.loader =  false;
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.loader =  false;
          this.$swal("Error", error.response.data.message, "error");
        });
    },
  },
};
</script>



